<template>
  <div ref="container">
    <span class="text-5xl tabular-nums leading-tight text-yellow-500 lg:text-6xl lg:leading-tight"
      >{{ animatednumber }}{{ plus ? '+' : '' }}</span
    >
    <div
      class="text-normal font-normal text-white lg:text-lg lg:font-medium"
      v-html="description" />
  </div>
</template>

<script setup lang="ts">
  import { onMounted, ref, useTemplateRef } from 'vue'

  import { animate, inView } from 'motion'

  type numberCounter = {
    number: number
    plus: boolean
    description: string
  }

  const props = defineProps<numberCounter>()
  const animatednumber = ref(0)

  const container = useTemplateRef<HTMLDivElement>('container')

  onMounted(() => {
    inView(
      container.value,
      () => {
        animate(progress => (animatednumber.value = Math.round(progress * props.number)), {
          duration: 2,
          easing: 'ease-out'
        })
      },
      { amount: 0.4 }
    )
  })
</script>
